var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.optionsAndThemes.length)?_c('div',{staticClass:"quick-search",attrs:{"data-qa":"quick-search"}},[_c('RelatedCollections',{attrs:{"title":_vm.$t('header.quickSearch'),"related-collections":_vm.optionsAndThemes}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }